import { StyleSheet } from "react-native";
import { useTranslation } from "react-i18next";

import { SegmentedTabs } from "../primitives/SegmentedTabs";
import type { UiTheme } from "../theme";

export type DiaryMode = "list" | "calendar";

const MODES = ["list", "calendar"] as const;
const styles = StyleSheet.create({ fill: { flex: 1 } });

// #368: List | Calendar, the diary's two views (mockup .seg).
export function DiaryModeSwitch({
  theme,
  mode,
  disabled,
  onChange,
}: {
  theme: UiTheme;
  mode: DiaryMode;
  disabled: boolean;
  onChange: (m: DiaryMode) => void;
}) {
  const { t } = useTranslation();
  return (
    <SegmentedTabs
      theme={theme}
      options={MODES}
      selected={mode}
      label={(m) => (m === "list" ? t("mobile.workouts.modeList") : t("mobile.workouts.modeCalendar"))}
      onChange={onChange}
      disabled={disabled}
      style={styles.fill}
    />
  );
}
